import { crpCommunicationsCuratedBaseApi } from "./crpCommunicationsBaseApi";


const graph_API_Route = '/graph_api'
const getScheduleURL = "get_schedule"
const scheduleEventUrl = "schedule_meeting"

export const OutlookCalendarApi = crpCommunicationsCuratedBaseApi.injectEndpoints({
    endpoints: (build) => ({
        getSchedule: build.mutation({
            query: (body) => {
                return {
                    url: `${graph_API_Route}/${getScheduleURL}?email=nikesh.singh@jaspercolin.com`,
                    body: body,
                    method: "POST"
                }
            }
        }),
        scheduleEvent: build.mutation({
            query: (body) => {
                return {
                    url: `${graph_API_Route}/${scheduleEventUrl}?email=${body.sPocEmail}`,
                    body,
                    method: "POST"
                }
            },
            transformResponse: (response) => response.spocData
        })
    })
})

export const { useGetScheduleMutation, useScheduleEventMutation } = OutlookCalendarApi